import { translationKey } from '../../i18n';
import { localize, readAppLanguage } from '../../i18n';
// 캐릭터 레벨 메타데이터. 라벨/색상은 백엔드에서도 내려오지만 (levelLabel),
// SVG 선택을 위한 매핑은 여기서 관리.

export const LEVEL_COUNT = 13; // L0 ~ L12

// 레벨별 라벨 fallback (백엔드 levelLabel을 우선 사용)
export const LEVEL_LABELS = [
    translationKey('빈 둥지'), translationKey('알'), translationKey('부화 직전'), translationKey('아기 병아리'), translationKey('호기심 병아리'),
    translationKey('어린 새'), translationKey('다 자란 새'), translationKey('멋쟁이 새'), translationKey('전설의 새'),
    translationKey('빛나는 새'), translationKey('무지개 새'), translationKey('황금 새'),
    translationKey('신화의 새'),
];

// 레벨별 테마 색상 — 캐릭터 노랑(#FFE066)과 통일.
// gauge: 채워진 시작 색 (밝은 노랑), accent: 끝 색 (살짝 오렌지로)
const LEVEL_THEME = [
    { gauge: '#E0E0E0', accent: '#BDBDBD' }, // L0 grey (시작 전)
    { gauge: '#FFE066', accent: '#FFD23F' }, // L1
    { gauge: '#FFE066', accent: '#FFD23F' }, // L2
    { gauge: '#FFE066', accent: '#FFC107' }, // L3
    { gauge: '#FFE066', accent: '#FFB300' }, // L4
    { gauge: '#FFE066', accent: '#FFA726' }, // L5
    { gauge: '#FFD93B', accent: '#FF9800' }, // L6
    { gauge: '#FFD93B', accent: '#FB8C00' }, // L7 (gold-ish)
    { gauge: '#FFD93B', accent: '#F57C00' }, // L8 (legend)
    { gauge: '#FFD93B', accent: '#FFA000' }, // L9 별1
    { gauge: '#FFE082', accent: '#FF8F00' }, // L10 별2
    { gauge: '#FFE082', accent: '#FFAB00' }, // L11 후광
    { gauge: '#FFEB3B', accent: '#FFC400' }, // L12 전설II
];

export function getLevelTheme(level) {
    const clamped = Math.max(0, Math.min(LEVEL_COUNT - 1, level || 0));
    return LEVEL_THEME[clamped];
}

export function getLevelLabel(level) {
    const clamped = Math.max(0, Math.min(LEVEL_COUNT - 1, level || 0));
    return LEVEL_LABELS[clamped];
}

// Keep Korean server copy verbatim; translate overseas names by the stable level index.
export function getLocalizedLevelLabel(level, serverLabel) {
    if (readAppLanguage() === 'ko') return serverLabel ?? getLevelLabel(level);
    return localize(getLevelLabel(level));
}
